import React__default from 'react';

const defaultValue = {
    MINIMAL: [],
    SMALL: [],
    MEDIUM: [],
    LARGE: [],
    COMPLETE: []
};
const AddressConfigurationContext = /*#__PURE__*/ React__default.createContext(defaultValue);
const AddressConfigurationProvider = ({ children , settings =defaultValue ,  })=>/*#__PURE__*/ React__default.createElement(AddressConfigurationContext.Provider, {
        value: settings
    }, children)
;
var AddressConfigurationProvider$1 = AddressConfigurationProvider;
const useAddressConfiguration = ()=>React__default.useContext(AddressConfigurationContext)
;

export { AddressConfigurationProvider$1 as default, defaultValue, useAddressConfiguration };
//# sourceMappingURL=AddressConfigurationContext.js.map
